import styled from "styled-components";
import { StyleTransition } from "react-transitioning";

import { User } from "../../types";

import { Button } from "../atoms/Button";
import { hexToRGB } from "../../utils/style";
import { Typography } from "../atoms/Typography";

/**
 * HAMBURGER MENU
 */

export type HamburgerMenuProps = {
  isOpen: boolean;
  user: Partial<User>;
  toggleMenu: () => void;
  onLogoutClick: () => void;
};

const styles = {
  enter: {
    opacity: 0,
  },
  enterActive: {
    opacity: 1,
    transition: "all 300ms ease-in-out",
  },
  exit: {
    opacity: 1,
  },
  exitActive: {
    opacity: 0,
    transition: "all 300ms ease-in-out",
  },
};

const Container = styled.div`
  width: 240px;
  height: 339px;
  position: absolute;
  top: 38px;
  right: 0;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid ${(props) => props.theme.colors.primaryBorder};
  background-color: ${(props) => props.theme.colors.primaryBackground};
  box-shadow: 8px 8px 8px
    ${(props) => hexToRGB(props.theme.colors.secondaryBackground, 0.06)};
  display: flex;
  flex-direction: column;
  z-index: 1;
`;

const UserBlock = styled.div`
  flex: 3;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${(props) => props.theme.colors.primaryBorder};
`;

const UserArea = styled.div`
  flex: 4;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    margin-bottom: 17px;
  }
`;

const NameWrapper = styled.div`
  margin-bottom: 8px;
`;

const AuthorityWrapper = styled.div`
  opacity: 0.8;
`;

const LogoutBlock = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LogoutButtonWrapper = styled.div`
  width: 180px;
  height: 44px;
`;

export const HamburgerMenu = ({
  isOpen = false,
  user,
  toggleMenu,
  onLogoutClick,
}: HamburgerMenuProps) => {
  const logoutClick = () => {
    toggleMenu();
    onLogoutClick!();
  };

  return (
    <StyleTransition in={isOpen} duration={300} styles={styles} enter exit>
      <Container>
        <UserBlock>
          <UserArea>
            {user.image && (
              <img src={user.image} width="72" height="72" alt={"user_icon"} />
            )}
            <NameWrapper>
              <Typography size={2} bold>
                {user.name}
              </Typography>
            </NameWrapper>
            <AuthorityWrapper>
              <Typography size={1}>{user.authority}</Typography>
            </AuthorityWrapper>
          </UserArea>
        </UserBlock>
        <LogoutBlock>
          <LogoutButtonWrapper>
            <Button buttonType={"danger"} ghost={true} onClick={logoutClick}>
              <Typography size={2}>ログアウト</Typography>
            </Button>
          </LogoutButtonWrapper>
        </LogoutBlock>
      </Container>
    </StyleTransition>
  );
};
